/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { ConfigQuery as SourceConfigQuery } from 'SourceQuery/Config.query';
import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/Config/Query */
export class ConfigQuery extends SourceConfigQuery {
    _getStoreConfigFields() {
        return [
            ...super._getStoreConfigFields(),
            'locale',
            'name',
            'postcode_minlength',
            'telephone_minlength',
            'telephone_minlength_with_mask',
            'telephone_prefix',
            'telephone_standard',
            'telephone_exceptionmasks',
            'googleApiKey',
            'isCloudinaryCDNActive',
            'plp_promo_tile_position',
            'is_url_rewrites_token_enabled',
            'countryFlagPath',
            'isSubscriptionPopupActive',
            'subscriptionPopupHeading',
            'subscriptionPopupCta',
            'subscriptionPopupTerms',
            'subscriptionPopupButton',
            'is_url_rewrites_token_enabled',
            'isSubscriptionBlockActive',
            'subscriptionBlockHeading',
            'subscriptionBlockPromo',
            'subscriptionBlockDisclaimer',
            'subscriptionBlockAdditional',
            'subscriptionBlockCta',
            'subscriptionBlockImage',
            'countryFlagPath',
            'google_optimize',
            'store_code',
            'wpp_number',
            'time_from',
            'time_to',
            'work_days',
            'wpp_text_message',
            'free_shipping_subtotal',
            'freeShippingMessageEnabled',
            'freeShippingMessage',
            'freeShippingMessageStyle',
            'is_segmentify_enabled',
            'cash_on_delivery_fee',
            'isNavOnTop',
            'filterTitle',
            'use_thumbnail_as_swatch',
            'pdp_widgets_order',
            'promo_excluded_notice',
            'sticky_subscribe_text',
            this.getConfigurableProductsAttrsTypeField(),
            this.getTabbyWidgetPdp(),
            this.getTamaraWidgetPdp()
        ];
    }

    getConfigurableProductsAttrsTypeField() {
        return new Field('configurableProductsAttrs')
            .addFieldList([
                'size_attr_id',
                'color_attr_id'
            ]);
    }

    getTabbyWidgetPdp() {
        return new Field('getTabbyWidgetPdp')
            .addFieldList([
                'script_url',
                'selector',
                'merchantCode',
                'publicKey',
                'source',
                'currency',
                'currencyRate',
                'theme',
                'productType',
                'error'
            ]);
    }

    getTamaraWidgetPdp() {
        return new Field('getTamaraWidgetPdp')
            .addFieldList([
                'script_url',
                'public_key',
                'currency_code',
                'country_code',
                new Field('payment_method')
                    .addFieldList([
                        'name',
                        'min_limit',
                        'max_limit',
                        'currency',
                        'number_of_instalments',
                        'description'
                    ]),
                'error'
            ]);
    }
}

export default new ConfigQuery();
